module.exports = __webpack_public_path__ + "img/andreasbuetlerlogo.c818e3de.svg";